export default "<app-header></app-header>\n\n<!-- <main> -->\n  <router-outlet></router-outlet>\n<!-- </main> -->\n\n<app-footer></app-footer>"